<template>
  <div>
    <div v-if="data" class="ji" :style="barSpace">
      <tab :tabs="tabs" v-model="tab" ref="tabs" :bullets="false" :voya="true"></tab>

      <fieldset id="tab-general" v-show="tab == 'general'" class="ji-fieldset">
        <!-- Başlık -->
        <div class="ji-card">
          <h1 class="ji-title">{{ data.Title }}</h1>
          <div class="ji-meta">
            <span class="ji-tracking">{{ data.TrackingNo | trackingNo }}</span>
            <span class="ji-chip" :class="'ji-chip-' + jobStatusClass">{{ jobStatusLabel }}</span>
          </div>
        </div>

        <!-- Bilgiler -->
        <div class="ji-card" v-show="data.Description || data.CirculationProfileSchema || data.TargetDate || data.DocumentType">
          <div class="ji-row ji-row-stack" v-show="data.Description">
            <div class="ji-label">Açıklama</div>
            <div class="ji-value ji-value-text">{{ data.Description }}</div>
          </div>
          <div class="ji-row" v-if="data.CirculationProfileSchema">
            <div class="ji-label">Dolaşım Profili</div>
            <div class="ji-value">{{ data.CirculationProfileSchema.Name }}</div>
          </div>
          <div class="ji-row" v-show="data.TargetDate">
            <div class="ji-label">Hedeflenen Bitiş</div>
            <div class="ji-value">{{ data.TargetDate | date }}</div>
          </div>
          <div class="ji-row">
            <div class="ji-label">Türü</div>
            <div class="ji-value">
              <job-document-type :documentType="data.DocumentType" />
              <span v-show="data.Amount" class="ji-amount">
                — {{ data.Amount | money }} {{ data.Currency }}
              </span>
            </div>
          </div>
        </div>

        <!-- Dosyalar -->
        <div class="ji-card">
          <div class="ji-section-title">Dosyalar</div>
          <div class="ji-files">
            <file-download-link
              v-for="d in data.Documents"
              :key="d.Id || d.id"
              :isActive="userActions.CanDownload"
              :isOnlineView="onlineViewEnabled"
              :document="d"
              :voya="true"
              @download="downloadDocument"
              @preview="showFilePreview"
              :isDocumentFormat="isFilePattern"
            ></file-download-link>
          </div>
        </div>

        <!-- Ekler -->
        <div class="ji-card" v-show="data.Attachments && data.Attachments.length > 0">
          <div class="ji-section-title">Ekler</div>
          <div class="ji-files">
            <file-download-link
              v-for="d in data.Attachments"
              :key="d.Id || d.id"
              :isActive="userActions.CanDownload"
              :isOnlineView="onlineViewEnabled"
              :document="d"
              :voya="true"
              @download="downloadAttachment"
              @preview="showAttachmentPreview"
              :isDocumentFormat="isFilePattern"
            ></file-download-link>
          </div>
        </div>
      </fieldset>
      <fieldset id="tab-flowsummary" v-show="tab == 'flowsummary'" class="ji-fieldset">
        <div class="ji-card">
          <div class="ji-flow" v-if="data.FlowSummary && data.FlowSummary.length > 0">
            <div
              v-for="(s, index) in data.FlowSummary"
              :key="s.Date"
              class="ji-flow-row"
              :class="['ji-flow-' + flowState(s).key, { 'ji-flow-row-last': index == data.FlowSummary.length - 1 }]"
            >
              <div class="ji-flow-rail">
                <span class="material-symbols-outlined ji-flow-icon" :title="flowState(s).title">{{ flowState(s).icon }}</span>
                <span class="ji-flow-line"></span>
              </div>

              <div class="ji-flow-body">
                <div v-if="s.TargetSystem" class="ji-flow-target">
                  Alıcı: <b>{{ s.TargetSystem.Name }}</b>
                </div>

                <div v-for="u in s.Relateds" :key="u.Id" class="ji-flow-user">
                  <img v-if="u.Type == 'SignGroup'" src="../assets/sign-group.png" class="ji-flow-avatar" alt="" />
                  <img v-else :src="getDefaultProfilePictureIfNull(u.ProfilePictureUrl)" class="ji-flow-avatar" alt="" />
                  <span class="ji-flow-name">{{ u.Name }}</span>
                  <span class="ji-flow-tag" v-if="u.Type == 'External'">Dış Kullanıcı</span>
                  <span class="ji-flow-tag" v-if="u.Type == 'SignGroup'">İmza Grubu</span>
                  <span class="ji-flow-tag" v-if="u.GroupName">İmza Grubu - {{ u.GroupName }}</span>
                </div>

                <div class="ji-flow-desc" :class="{ 'ji-flow-desc-struck': s.Tense == 'Canceled' }">
                  <template v-if="s.Tense != 'Canceled'">
                    <span v-if="s.Type == 'Cancel'" class="material-symbols-outlined ji-flow-type ji-flow-type-warning">remove_circle</span>
                    <span v-if="s.Type == 'Decline'" class="material-symbols-outlined ji-flow-type ji-flow-type-danger">cancel</span>
                    <span v-if="s.Type == 'UndoCancel'" class="material-symbols-outlined ji-flow-type ji-flow-type-primary">undo</span>
                  </template>
                  {{ s.Description }}
                </div>
                <div class="ji-flow-note" v-show="s.Note">{{ s.Note }}</div>
                <div class="ji-flow-date">{{ s.Date | datetime }}</div>
              </div>
            </div>
          </div>
          <div v-else class="ji-flow-empty">Dolaşım adımı bulunamadı.</div>
        </div>
      </fieldset>
      <div class="ji-bar" v-if="actionCount > 0 && !fileDetail && !multipleFiles">
        <div class="ji-bar-inner" role="group">
          <button
            type="button"
            class="ji-btn ji-btn-danger"
            @click="$emit('decline')"
            v-if="userActions.CanDecline"
          >
            Reddet
          </button>
          <button
            type="button"
            class="ji-btn ji-btn-success"
            @click="approve"
            v-if="userActions.CanApprove"
          >
            Onayla
          </button>
          <button
            type="button"
            class="ji-btn ji-btn-success"
            @click="initial"
            v-if="userActions.CanInitial"
          >
            Parafla
          </button>
          <button
            type="button"
            class="ji-btn ji-btn-navy"
            @click="$emit('sign')"
            v-if="userActions.CanSign"
          >
            Mobil İmzala
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="note note-warning">
        <h3>Bilgi</h3>
        <p>Kayıt bulunamadı.</p>
      </div>
    </div>
    <bottom-sheet
      v-if="isOTPPanelVisible"
      title="SMS Kimlik Doğrulama"
      :persistent="true"
      @close="isOTPPanelVisible = false"
    >
      <div v-if="this.validationResult">
        <form @submit.prevent="validate">
          <fieldset :disabled="loading" class="ji-otp-fieldset">
            <p class="ji-otp-text" v-if="this.validationResult.Mobile">
              <b>{{ this.validationResult.Mobile }}</b> numaralı telefonunuza doğrulama kodu SMS
              olarak gönderilmiştir ve kısa süre içerisinde ulaşacaktır.
            </p>
            <p class="ji-otp-text" v-else>
              Telefonunuza doğrulama kodu SMS olarak gönderilmiştir ve kısa süre içerisinde ulaşacaktır.
            </p>

            <label class="ji-otp-label" for="jiOtp">Lütfen telefonunuza gelen doğrulama kodunu giriniz:</label>
            <input
              id="jiOtp"
              v-model="approveForm.OTP"
              type="text"
              class="ji-otp-input"
              autocomplete="one-time-code"
              aria-describedby="validationCodeHelp"
              required
            />
            <div v-if="errorMessage" class="ji-otp-error">
              <span class="material-symbols-outlined">error</span>
              <span>Hata : {{ errorMessage }}</span>
            </div>
            <div v-show="processingMessage" class="ji-otp-processing">
              <span class="ji-otp-spinner"></span>
              {{ processingMessage }}
            </div>
          </fieldset>
        </form>
      </div>
      <div v-else>
        <div v-show="processingMessage" class="ji-otp-processing">
          <span class="ji-otp-spinner"></span>
          Yükleniyor...
        </div>
      </div>
      <div class="ji-otp-actions">
        <button type="button" class="ji-btn ji-btn-outline" @click="isOTPPanelVisible = false">
          Kapat
        </button>
        <button type="button" class="ji-btn ji-btn-success" :disabled="loading" @click="validate">
          Doğrula
        </button>
      </div>
    </bottom-sheet>
    <file-preview v-if="fileDetail" :file="fileDetail" :viewer="viewerType" :isOnlineView="onlineViewEnabled" @close="fileDetail=null;"></file-preview>
    <MultipleViewer v-if="multipleFiles" :clickedFileId="clickedFileId" :viewer-type="viewerType" :files="multipleFiles" @closeMultipleFilePreview="multipleFiles = null"></MultipleViewer>
  </div>
</template>
<script>
import axios from "axios";
import JobDocumentType from "../components/JobDocumentType.vue";
import tab from "../components/Tab.vue";
import FileDownloadLink from "./FileDownloadLink.vue";
import FilePreview from "./FilePreview.vue";

import MultipleViewer from "./MultipleViewer.vue";
import BottomSheet from "./Voya/BottomSheet.vue";

export default {
  components: {
    JobDocumentType,
    tab,
    FileDownloadLink,
    FilePreview,
    MultipleViewer,
    BottomSheet
  },
  data() {
    return {
      documentInfo: null,
      fileDetail: null,
      onlineViewEnabled: true,
      isOTPPanelVisible: false,
      validationResult: {},
      errorMessage: null,
      processingMessage: null,
      approveForm: {},
      tab: "general",
      tabs: [
        { key: "general", text: "İş Bilgileri" },
        { key: "flowsummary", text: "Dolaşım Adımları" },
      ],
      multipleFiles: null,
      clickedFileId: null, 
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    userActions: {
      type: Object,
      required: true,
    },
  },
  created(){
    this.getOnlineViewPermission()
        .then(x => {
          console.log(x)
            this.onlineViewEnabled = x;
        }).catch(x => {
            console.warn("getOnlineViewPermission alınamadı:", x);
            this.onlineViewEnabled = true;
        });
  },
  computed: {
    actionCount() {
      var a = this.userActions;
      if (!a) return 0;
      return [a.CanDecline, a.CanApprove, a.CanInitial, a.CanSign].filter(Boolean).length;
    },
    barSpace() {
      // Sabit alt çubuğun içeriği örtmemesi için sayfa altına boşluk bırakır (butonlar 2'li satırlara sarılır)
      if (this.actionCount == 0) return null;
      var rows = Math.ceil(this.actionCount / 2);
      return { paddingBottom: "calc(" + (rows * 56 + 40) + "px + env(safe-area-inset-bottom, 0px))" };
    },
    jobStatusLabel() {
      if (!this.data || !this.data.State) return null;
      return this.$izonay.jobStatus[this.data.State]?.text;
    },
    jobStatusClass() {
      if (!this.data || !this.data.State) return null;

      return this.$izonay.jobStatus[this.data.State]?.css;
    },
    isFilePattern(){
        var filePatternFound = true;
        this.data.Finalizers.forEach(finalizer => {
            if(finalizer.TargetSystem.DocumentFormat == null || finalizer.TargetSystem.DocumentFormat == 'None'){
                filePatternFound = false;
            }
        });
        return filePatternFound;
    }
  },
  methods: {
    flowState(s) {
      // Dolaşım adımının durumuna göre ikon, başlık ve renk anahtarı
      if (s.Tense == "Past" && s.Type == "Decline")
        return { key: "danger", icon: "cancel", title: "İşlem reddedildi" };
      if (s.Tense == "Past" && s.Type == "Cancel")
        return { key: "warning", icon: "remove_circle", title: "İşlem iptal edildi" };
      if (s.Tense == "Past")
        return { key: "success", icon: "check_circle", title: "İşlem tamamlandı" };
      if (s.Tense == "Present")
        return { key: "primary", icon: "arrow_circle_right", title: "Bu işlem bekleniyor" };
      if (s.Tense == "Future")
        return { key: "muted", icon: "schedule", title: "İşlem henüz gerçekleşmedi" };
      return { key: "warning", icon: "remove_circle", title: "İşlem iptal edildi" };
    },
    showFilePreview(document, type, isFormatted,isDropdownClick) {
      if(document.SignedFile && type == 'pdf' && !isDropdownClick){
          document.IsSigned = true;
      }
      if(isDropdownClick){
          document.IsSigned = false;
      }
      this.viewerType = type;
      if(this.data.Documents.length > 1){
        this.clickedFileId = document.Id
        this.multipleFiles = this.data.Documents
        this.multipleFiles.map(x => {
            x.UnsignedFile.EntityType = 'job';
            x.UnsignedFile.EntityId =  this.data.Id
            x.IsAttachment = false
            if(isFormatted)
                x.IsFormatted = true;
            else
                x.IsFormatted = false;
        } )
      }else{
        this.fileDetail = document;
        this.fileDetail.EntityId = this.data.Id;
        if(isFormatted)
            this.fileDetail.IsFormatted = true;
        else
            this.fileDetail.IsFormatted = false;
      }
    },
    showAttachmentPreview(document, type, isFormatted) {
            this.viewerType = type;
            if(this.data.Attachments.length > 1){
                this.clickedFileId = document.Id
                this.multipleFiles = this.data.Attachments
                this.multipleFiles.map(x => {
                    x.EntityType = 'job';
                    x.EntityId =  this.data.Id
                    x.IsAttachment = true
                    if(isFormatted)
                        x.IsFormatted = true;
                    else
                        x.IsFormatted = false;
                } )
            }else{
                this.fileDetail = document;
                this.fileDetail.EntityId = this.data.Id;
                if(isFormatted)
                    this.fileDetail.IsFormatted = true;
                else
                    this.fileDetail.IsFormatted = false;
            }
        },
    downloadDocument(document,menuKey) {
      // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
     
      return axios
        .post(`/job/createDocumentUrl/`, {
          EntityId: this.data.Id,
          DocumentId: document.Id,
          IsSigned: menuKey == 'downloadSigned' ? true : false,
          IsFormatted: menuKey == 'downloadFormatted' ? true : false,
        })
        .then((x) => {
          console.log("createDocumentUrl Result:", x.data);
          this.documentInfo = {
            FileName: document.UnsignedFile.FileName,
            Size: document.UnsignedFile.Size,
            Url: x.data.Data.Url,
          };
          if(this.isIOS()){
            window.location = x.data.Data.Url
          }else {
            window.open(x.data.Data.Url);
          }
          
          
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
    downloadAttachment(attachment) {
      // İndirilecek ek dosya için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
      return axios
        .post(`/job/createAttachmentUrl/`, {
          EntityId: this.data.Id,
          AttachmentId: attachment.Id,
        })
        .then((x) => {
          console.log("createAttachmentUrl Result:", x.data);
          attachment.Url = x.data.Data.Url;

          this.documentInfo = {
            FileName: attachment.FileName,
            Size: attachment.Size,
            Url: x.data.Data.Url,
          };

          this.documentInfo = attachment;
          console.log(JSON.stringify(this.documentInfo));
          if(this.isIOS()){
            window.location = x.data.Data.Url
          }else {
            window.open(x.data.Data.Url);
          }
        })
        .catch((x) => {
          switch (x.response.status) {
            case 404:
              this.$izonayAlert("Kayıt bulunamadı.");
              break;
            default:
              this.errorMessage = "İşlem gerçekleştirilemedi: " + x;
              break;
          }
          this.loading = false;
        });
    },
    approve() {
      this.loading = true;
      var url = `/job/approve/`;
      return axios
        .post(url, { JobId: this.$route.params.id, description: "" })
        .then((x) => {
          console.log("POST Result:", x.data);
          if(x.data.Data.SessionId){
            this.validationResult = x.data.Data;
            this.isOTPPanelVisible = true
            console.log(this.validationResult)
          }
          else if (x.data.Success) {
            this.data = x.data.Data.Job;
            this.userActions = x.data.Data.UserActions;
            this.$izonayAlert("Belgeleriniz başarıyla onaylanmıştır.", "success");
            this.view = "detail";
          } else {
            this.$izonayAlert(x.data.ErrorMessages);
          }

          this.loading = false;
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
    initial() {
      this.loading = true;
      var url = `/job/initial/`;
      return axios
        .post(url, { JobId: this.$route.params.id, description: "" })
        .then((x) => {
          console.log("POST Result:", x.data);
          if (x.data.Success) {
            this.data = x.data.Data.Job;
            this.userActions = x.data.Data.UserActions;
              this.$izonayAlert("Belgeleriniz başarıyla paraflanmıştır.", "success");
            this.view = "detail";
          } else {
            this.$izonayAlert(x.data.ErrorMessages);
          }

          this.loading = false;
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
    validate(){
        this.loading = true;
        this.processingMessage = "Doğrulanıyor..."
        var url = `/job/ApproveOTPJob/`;
        axios.post(url, {SessionId: this.validationResult.SessionId , OTP: this.approveForm.OTP, JobId: this.$route.params.id, description: this.description ?? "" }, { silent: true })
        .then(x => {
            if(x.data.Success){
                console.log("Başarılı")
                this.data = x.data.Data.Job;
                this.userActions = x.data.Data.UserActions;
                this.description = null;
                this.$izonayAlert("Belgeleriniz başarıyla onaylanmıştır. İşleminiz zaman damgalı loglanmıştır.", "success");
                this.$router.push({ name:'Job' });
            } else{
                this.$izonayAlert(x.data.ErrorMessages);
            }
        this.loading = false;
        this.isOTPPanelVisible = false;
        })
        .catch(x => window.processErrorResponse(x, this));
    },
  },
};
</script>
<style scoped>
/* Voya: iş detayı */
.ji {
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  color: #092154;
}

/* SMS doğrulama (alttan açılan sayfa) */
.ji-otp-fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.ji-otp-text {
  margin: 0 0 16px 0;
  font-size: 14px;
  line-height: 150%;
  color: #4D4D4D;
}

.ji-otp-text b {
  font-weight: 600;
  color: #092154;
}

.ji-otp-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: #333333;
}

.ji-otp-input {
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  padding: 0 14px;
  border: 1px solid #E6E9EE;
  border-radius: 8px;
  outline: none;
  background-color: #ffffff;
  font-family: inherit;
  /* iOS'ta odaklanınca sayfanın yakınlaşmaması için 16px üstü */
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
  text-align: center;
  color: #092154;
}

.ji-otp-input:focus {
  border-color: #182F5E;
  box-shadow: 0 0 0 3px rgba(24, 47, 94, 0.12);
}

.ji-otp-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #FDECEE;
  font-size: 13px;
  line-height: 150%;
  color: #B02A37;
}

.ji-otp-error .material-symbols-outlined {
  flex-shrink: 0;
  font-size: 20px;
}

.ji-otp-processing {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  font-weight: 500;
  font-size: 13px;
  color: #097DFF;
}

.ji-otp-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #CFE5FF;
  border-top-color: #097DFF;
  border-radius: 50%;
  animation: ji-otp-spin 0.8s linear infinite;
}

@keyframes ji-otp-spin {
  to {
    transform: rotate(360deg);
  }
}

.ji-otp-actions {
  display: flex;
  gap: 8px;
  margin-top: 20px;
}

/* Sabit alt işlem çubuğu */
.ji-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  padding: 12px 16px calc(env(safe-area-inset-bottom, 0px) + 12px) 16px;
  border-top: 1px solid #EFEFEF;
  background-color: #ffffff;
  box-shadow: 0 -4px 16px rgba(9, 33, 84, 0.08);
}

.ji-bar-inner {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 560px;
  margin: 0 auto;
}

.ji-btn {
  flex: 1 1 140px;
  height: 48px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-size: 15px;
  white-space: nowrap;
  color: #ffffff;
}

.ji-btn-success {
  background-color: #1E9E57;
}

.ji-btn-success:active {
  background-color: #188547;
}

.ji-btn-navy {
  background-color: #092154;
}

.ji-btn-navy:active {
  background-color: #182F5E;
}

.ji-btn-outline {
  border-color: #182F5E;
  background-color: #ffffff;
  color: #182F5E;
}

.ji-btn-outline:active {
  background-color: #F4F6FA;
}

.ji-btn:disabled {
  opacity: 0.6;
}

.ji-btn-danger {
  border-color: #DC3545;
  background-color: #ffffff;
  color: #DC3545;
}

.ji-btn-danger:active {
  background-color: #FDECEE;
}

.ji-fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.ji-card {
  box-sizing: border-box;
  margin-top: 12px;
  padding: 16px;
  border: 1px solid #EFEFEF;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 2px 12px rgba(9, 33, 84, 0.06);
}

.ji-title {
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: #092154;
  word-break: break-word;
}

.ji-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.ji-tracking {
  padding: 2px 10px;
  border-radius: 100px;
  background-color: #F1F7FF;
  font-weight: 600;
  font-size: 12px;
  color: #092154;
}

.ji-chip {
  padding: 2px 10px;
  border-radius: 100px;
  background-color: #ECEEF2;
  font-weight: 500;
  font-size: 12px;
  color: #5C6578;
}

.ji-chip-primary { background-color: #E9F4FF; color: #097DFF; }
.ji-chip-info { background-color: #E3F6FA; color: #0E7C94; }
.ji-chip-success { background-color: #E4F6EA; color: #1E8E4A; }
.ji-chip-warning { background-color: #FFF1E3; color: #D9660C; }
.ji-chip-danger { background-color: #FDE8EA; color: #C62C3A; }

.ji-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  box-sizing: border-box;
  min-height: 48px;
  padding: 12px 0;
  border-bottom: 1px solid #EFEFEF;
}

.ji-row:last-child {
  border-bottom: none;
}

.ji-row-stack {
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.ji-label {
  flex: 0 0 auto;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: #808080;
}

.ji-value {
  flex: 1 1 auto;
  min-width: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: right;
  color: #333333;
  word-break: break-word;
}

.ji-value-text {
  width: 100%;
  text-align: left;
  white-space: pre-line;
}

.ji-amount {
  color: #808080;
}

/* Dolaşım adımları: dikey zaman çizelgesi */
.ji-flow {
  display: flex;
  flex-direction: column;
}

.ji-flow-row {
  display: flex;
  align-items: stretch;
  gap: 12px;
}

.ji-flow-rail {
  flex: 0 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ji-flow-icon {
  flex-shrink: 0;
  font-size: 24px;
  font-variation-settings: 'FILL' 1;
}

.ji-flow-line {
  flex: 1 1 auto;
  width: 2px;
  margin: 4px 0;
  border-radius: 2px;
  background-color: #E6E9EE;
}

.ji-flow-row-last .ji-flow-line {
  visibility: hidden;
}

.ji-flow-success .ji-flow-icon { color: #1E9E57; }
.ji-flow-danger .ji-flow-icon { color: #DC3545; }
.ji-flow-warning .ji-flow-icon { color: #F37615; }
.ji-flow-primary .ji-flow-icon { color: #097DFF; }
.ji-flow-muted .ji-flow-icon { color: #B8BEC9; }

.ji-flow-body {
  flex: 1 1 auto;
  min-width: 0;
  padding-bottom: 18px;
}

.ji-flow-row-last .ji-flow-body {
  padding-bottom: 0;
}

.ji-flow-target {
  margin-bottom: 4px;
  font-size: 12px;
  color: #808080;
}

.ji-flow-target b {
  font-weight: 600;
  color: #333333;
}

.ji-flow-user {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.ji-flow-avatar {
  width: 28px;
  height: 28px;
  object-fit: cover;
  border-radius: 50%;
}

.ji-flow-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #333333;
}

.ji-flow-tag {
  padding: 0 8px;
  border-radius: 100px;
  background-color: #EEF1F5;
  font-weight: 400;
  font-size: 11px;
  line-height: 18px;
  color: #5C6578;
}

.ji-flow-desc {
  font-weight: 400;
  font-size: 13px;
  line-height: 150%;
  color: #4D4D4D;
}

.ji-flow-primary .ji-flow-desc {
  font-weight: 500;
  color: #097DFF;
}

.ji-flow-desc-struck {
  text-decoration: line-through;
}

.ji-flow-type {
  vertical-align: middle;
  font-size: 16px;
  font-variation-settings: 'FILL' 1;
}

.ji-flow-type-warning { color: #F37615; }
.ji-flow-type-danger { color: #DC3545; }
.ji-flow-type-primary { color: #097DFF; }

.ji-flow-note {
  margin-top: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  background-color: #F5F7FA;
  font-size: 12px;
  line-height: 140%;
  color: #4D4D4D;
}

.ji-flow-date {
  margin-top: 4px;
  font-size: 12px;
  color: #808080;
}

.ji-flow-empty {
  padding: 16px 0;
  text-align: center;
  font-size: 13px;
  color: #808080;
}

.ji-files {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ji-section-title {
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 15px;
  color: #092154;
}

.roundbox {
  background: #fff;
  border-radius: 8px;
  /* box-shadow: 0px 2px 1px 1px #DDDD; */
  padding-top: 1px;
}

.roundbox .rbcontent {
  padding: 20px 5px 20px 5px;
}

.roundbox .rbcontent.head {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 14px 30px 24px 30px;
}

.roundbox .rbcontent.form {
  background-color: #f7f7f7;
}

.roundbox .rbcontent.head h2 {
  position: relative;
  top: 8px;
  display: inline;
}

.roundbox .rbcontent.footer {
  padding: 14px 30px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.table-flow-summary td,
.table-flow-summary th {
  padding: 0.75rem;
  vertical-align: top;
}
.col-left {
  display: flow-root;
  width: 95%;
}
.flow-picture {
  width: 1.4em;
  height: 1.4em;
  vertical-align: middle;
  margin-right: 4px;
  border-radius: 1.2em;
}
.nav.nav-pills li a.active {
  background: none;
  border-bottom: 4px solid #35495e !important;
  color: #35495e;
}

.nav.nav-pills a {
  color: #808080 !important;
  border-radius: 0;
  background: #fff;
  border-bottom: 4px solid #fff;
  font-size: 18px;
  text-decoration: none !important;
}

.nav.nav-pills a:hover {
  background: none;
  color: #35495e;
}

a {
  color: #0d6efd !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}
.note-warning {
  border-color: #f0ad4e;
  background: #fcf8e3;
}

.note {
  margin: 0 0 20px 0;
  padding: 15px 30px 15px 15px;
  border-left: 3px solid #e5e5e5;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}
.note h1,
.note h2,
.note h3,
.note h4 {
  margin-top: 0;
}
.note p:last-child {
  margin-bottom: 0;
}
p {
  margin: 0 0 10px;
}

.fixed-right{
  position: absolute;
  right: 1rem;
}
.documentContainer{
  z-index: 1 !important;
  opacity: 1 !important;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
</style>
